import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import { getAllParams } from '../service/utils';

const AccessibilityListBox = ({ listboxId, hidden, children, selector, ...params }) => {

    useEffect(() => {

        const listboxElem = document.querySelector(`#${listboxId}`);
        const selectorElems = listboxElem.querySelectorAll(selector);
        const selectorElemsFirst = listboxElem.querySelector(selector);

        selectorElems.forEach((el, index) => {
            // remove focusable from all selctor elements and inputs
            el.setAttribute("tabindex", -1);
            const checkbox1 = el.querySelector('input');
            checkbox1?.setAttribute("tabindex", -1);
            // set first element focusable
            selectorElemsFirst.setAttribute("tabindex", 0);

            el.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.target.click();
                }
                if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                    event.target.setAttribute("tabindex", -1);
                    event.preventDefault();
                    const calcNext = event.key === 'ArrowDown' ? index + 1 : index - 1 + selectorElems.length;
                    const nextIndex = calcNext % selectorElems.length;
                    selectorElems[nextIndex].focus();
                    selectorElems[nextIndex].setAttribute("tabindex", 0);
                }
            });
        })
    }, [])

    return (
        <div role="listbox"
            id={listboxId}
            aria-labelledby={`${listboxId}Trigger`}
            aria-hidden={hidden}
            {...getAllParams(params)}>
            {children}
        </div>
    )
}

AccessibilityListBox.propTypes = window.config.developMode ? {
    listboxId: PropTypes.string.isRequired,
    hidden: PropTypes.bool.isRequired,
} : {};

export default AccessibilityListBox;